import { varName } from '../tokens/cssVar';
import type { SpaceKey } from '../tokens/space';

/** `spaceVar(4)` → `var(--gg-space-4)`; `spaceVar(0.5)` → `var(--gg-space-0-5)`. */
export const spaceVar = (key: SpaceKey): string => `var(${varName(`space.${key}`)})`;
